import '../../styles/pages/tags.scss';
import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: true });

const tagTextEl = document.querySelector('.grid-block__tag-text');
const tagTextBtnEl = tagTextEl.querySelector('button');
const tagTextPEl = tagTextEl.querySelector('p');

tagTextBtnEl.onclick = () => {
  tagTextPEl.classList.add('grid-block__tag-text_text-opened');
  tagTextBtnEl.classList.add('hidden');
}